import {
  PLAN_ACCESS,
  ROUTE_ACCESS,
  SECTION_ACCESS,
  SHIFT_MANAGERS_ACCESS,
} from "./userRoles";
import {
  ROOT,
  PLAN_MANAGEMENT,
  DRIVER_MANAGEMENT,
  ROUTE_MANAGEMENT,
  SECTION_MANAGEMENT,
  SHIFT_MANAGER_MANAGEMENT,
  VOLUME_OVERLAY_TABLE,
} from "./routes";

import Home from "../pages/HomePage";
import PlanManagement from "../pages/PlanManagement";
import DriverManagement from "../pages/DriverManagement";
import SectionManagement from "../pages/SectionManagement";
import RouteManagement from "../pages/RouteManagement";
import ShiftManagerManagement from "../pages/ShiftManagerManagement";
import VolumeOverlayTable from "../pages/VolumeOverlayTable";

export const PAGES = [
  {
    path: ROOT,
    element: Home,
  },
  {
    path: PLAN_MANAGEMENT,
    pageName: "Plan",
    element: PlanManagement,
    requiredRole: PLAN_ACCESS,
  },
  {
    path: DRIVER_MANAGEMENT,
    pageName: "Driver",
    element: DriverManagement,
    requiredRole: PLAN_ACCESS,
  },
  {
    path: ROUTE_MANAGEMENT,
    pageName: "Route",
    element: RouteManagement,
    requiredRole: ROUTE_ACCESS,
  },
  {
    path: SECTION_MANAGEMENT,
    pageName: "Section",
    element: SectionManagement,
    requiredRole: SECTION_ACCESS,
  },
  {
    path: SHIFT_MANAGER_MANAGEMENT,
    pageName: "Shift Manager",
    element: ShiftManagerManagement,
    requiredRole: SHIFT_MANAGERS_ACCESS,
  },
  {
    path: VOLUME_OVERLAY_TABLE,
    element: VolumeOverlayTable,
  },
];

export const PAGE_TITLE_ROUTE_MAP = [
  {
    routeName: ROOT,
    pageTitle: "Quantum Management",
  },
  {
    routeName: PLAN_MANAGEMENT,
    pageTitle: "Plan - Quantum Management",
    productTitle: "Plan Management",
  },
  {
    routeName: DRIVER_MANAGEMENT,
    pageTitle: "Driver - Quantum Management",
    productTitle: "Driver Management",
  },
  {
    routeName: ROUTE_MANAGEMENT,
    pageTitle: "Route - Quantum Management",
    productTitle: "Route Management",
  },
  {
    routeName: SECTION_MANAGEMENT,
    pageTitle: "Section - Quantum Management",
    productTitle: "Section Management",
  },
  {
    routeName: SHIFT_MANAGER_MANAGEMENT,
    pageTitle: "Shift Manager - Quantum Management",
    productTitle: "Shift Manager Management",
  },
];
